import { useRef, useState } from "react";
import { toast } from "sonner";
import { FileCheck2, Upload, Loader2, Eye } from "lucide-react";
import { api, formatApiError } from "@/lib/api";

export default function DocUpload({ docType, label, hint, doc, disabled, onUploaded, onView }) {
  const input = useRef(null);
  const [busy, setBusy] = useState(false);

  const upload = async (file) => {
    if (!file) return;
    if (file.size > 10 * 1024 * 1024) return toast.error("File must be 10 MB or smaller");
    const form = new FormData();
    form.append("doc_type", docType);
    form.append("file", file);
    setBusy(true);
    try {
      await api.post("/kyc/documents", form);
      toast.success(`${label} uploaded`);
      onUploaded();
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setBusy(false);
      input.current.value = "";
    }
  };

  return (
    <div className="rounded-2xl border border-dashed border-line bg-obsidian/40 p-5" data-testid={`kyc-upload-${docType}`}>
      <div className="flex items-start justify-between gap-4">
        <div>
          <p className="font-medium text-white">{label}</p>
          <p className="mt-1 text-xs text-slate-500">{hint}</p>
        </div>
        {doc && <FileCheck2 className="h-5 w-5 shrink-0 text-emerald-400" />}
      </div>
      {doc && (
        <button type="button" onClick={() => onView(doc)} className="mt-4 inline-flex items-center gap-2 text-sm text-emerald-400 hover:underline" data-testid={`kyc-view-${docType}`}>
          <Eye className="h-4 w-4" /> {doc.original_filename}
        </button>
      )}
      <input ref={input} type="file" accept=".jpg,.jpeg,.png,.webp,.pdf" className="hidden" onChange={(e) => upload(e.target.files[0])} data-testid={`kyc-file-input-${docType}`} />
      {!disabled && (
        <button type="button" disabled={busy} onClick={() => input.current.click()} className="btn-ghost mt-4 !px-4 !py-2 text-xs" data-testid={`kyc-upload-button-${docType}`}>
          {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Upload className="h-4 w-4" />} {doc ? "Replace file" : "Upload file"}
        </button>
      )}
    </div>
  );
}
